/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetUnproxiedMcpServerRequest,
  GetUnproxiedMcpServerSecurity,
} from "../models/operations/getunproxiedmcpserver.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildGetUnproxiedMcpServerQuery,
  GetUnproxiedMcpServerQueryData,
  prefetchGetUnproxiedMcpServer,
  queryKeyGetUnproxiedMcpServer,
} from "./getUnproxiedMcpServer.core.js";
export {
  buildGetUnproxiedMcpServerQuery,
  type GetUnproxiedMcpServerQueryData,
  prefetchGetUnproxiedMcpServer,
  queryKeyGetUnproxiedMcpServer,
};

export type GetUnproxiedMcpServerQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getServer unproxiedMcp
 *
 * @remarks
 * Get an unproxied MCP server by ID or slug. Exactly one of id or slug must be provided.
 */
export function useGetUnproxiedMcpServer(
  request?: GetUnproxiedMcpServerRequest | undefined,
  security?: GetUnproxiedMcpServerSecurity | undefined,
  options?: QueryHookOptions<
    GetUnproxiedMcpServerQueryData,
    GetUnproxiedMcpServerQueryError
  >,
): UseQueryResult<
  GetUnproxiedMcpServerQueryData,
  GetUnproxiedMcpServerQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildGetUnproxiedMcpServerQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getServer unproxiedMcp
 *
 * @remarks
 * Get an unproxied MCP server by ID or slug. Exactly one of id or slug must be provided.
 */
export function useGetUnproxiedMcpServerSuspense(
  request?: GetUnproxiedMcpServerRequest | undefined,
  security?: GetUnproxiedMcpServerSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    GetUnproxiedMcpServerQueryData,
    GetUnproxiedMcpServerQueryError
  >,
): UseSuspenseQueryResult<
  GetUnproxiedMcpServerQueryData,
  GetUnproxiedMcpServerQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildGetUnproxiedMcpServerQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setGetUnproxiedMcpServerData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      id?: string | undefined;
      slug?: string | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: GetUnproxiedMcpServerQueryData,
): GetUnproxiedMcpServerQueryData | undefined {
  const key = queryKeyGetUnproxiedMcpServer(...queryKeyBase);

  return client.setQueryData<GetUnproxiedMcpServerQueryData>(key, data);
}

export function invalidateGetUnproxiedMcpServer(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      id?: string | undefined;
      slug?: string | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "unproxiedMcp", "getServer", ...queryKeyBase],
  });
}

export function invalidateAllGetUnproxiedMcpServer(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "unproxiedMcp", "getServer"],
  });
}
